module.exports = __webpack_public_path__ + "img/soren_farfromhomes.59e4893.png";